import React from 'react';
import styled from 'styled-components';
import { NsList } from './customElements';
import { Tag } from './tag';

type Props = {
  date: string;
  tags: string[];
  className?: string;
  type: string;
};
const TimeStyle = styled.svg`
  width: 1rem;
  margin: 0 0.2rem;
  position: relative;
  top: 7px;
`;

const TimeIcon = () => (
  <TimeStyle
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </TimeStyle>
);

const Date = styled.dd`
  margin: 0;
  display: block;
  font-size: 0.8rem;
`;
const List = styled(NsList)`
  display: flex;
  align-items: center;
`;
const Wrap = styled.div`
  grid-area: subInfo;
  width: 100%;
`;
const SubInfo: React.VFC<Props> = ({ date, tags, className, type }) => (
  <Wrap className={className}>
    <Date>
      <TimeIcon />
      {date}
    </Date>
    <List>
      {tags.map((tag) => (
        <li key={tag}>
          <Tag type={type} name={tag} />
        </li>
      ))}
    </List>
  </Wrap>
);

export default SubInfo;
